import { render, staticRenderFns } from "./GooglePlayBadge.vue?vue&type=template&id=5094c196&"
import script from "./GooglePlayBadge.vue?vue&type=script&lang=js&"
export * from "./GooglePlayBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5094c196')) {
      api.createRecord('5094c196', component.options)
    } else {
      api.reload('5094c196', component.options)
    }
    module.hot.accept("./GooglePlayBadge.vue?vue&type=template&id=5094c196&", function () {
      api.rerender('5094c196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GooglePlayBadge.vue"
export default component.exports